<template>
    <div class="profile-card" :class="{'primary': !isDesktop}">
        <v-container fluid v-if="!profileLoading">
            <v-row>
                <v-col :cols="isDesktop ? 4 : 'auto'">
                    <v-card :height="isDesktop ? 200 : 70" flat class="transparent">
                        <v-container fluid class="pa-0 fill-height justify-center">
                            <profile-avatar :src="profile.avatar_url" 
                            :title="profile.username" :size="isDesktop ? 150 : 70" color="red"></profile-avatar>
                        </v-container>
                    </v-card>
                </v-col>
                <v-col :cols="isDesktop ? 8 : ''" style="overflow: hidden;">
                    <v-card flat class="transparent">
                        <v-list-item class="px-0" two-line>
                            <v-list-item-content class="content-auto">
                                <v-list-item-title class="font-weight-light" :class="[isDesktop ? 'display-1' : 'headline']">
                                    {{profile.username}}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="profile.account_type">
                                    {{ profile.account_type | role }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action v-if="editOptions">
                                <div class="d-flex align-center">
                                    <v-btn color="grey lighten-1" outlined small to="/account/edit/" v-if="isDesktop">
                                        <v-icon left>mdi-pencil</v-icon> Edit
                                    </v-btn>
                                    <v-btn fab small icon to="/account/edit/" v-else>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon color="secondaryDarker" v-if="isDesktop">
                                        <v-icon>mdi-settings-outline</v-icon>
                                    </v-btn>
                                </div>
                            </v-list-item-action>
                            <v-list-item-action v-else>
                                <btn-follow 
                                :following="profile.following" 
                                :loading="followUpdating" 
                                @followAction="follow(profile.id)" 
                                @unFollowAction="unFollow(profile.id)"></btn-follow>
                            </v-list-item-action>
                        </v-list-item>
                        <div>
                            <widget-rate :size=140 :value=70 :id="profile.username+'-rate'" :fill="$vuetify.theme.themes.light.starColor"></widget-rate>
                        </div>
                        <div class="d-flex flex-row flex-wrap mt-4" v-if="isDesktop">
                            <text-meta-count :metaName="profile.post_count > 1 ? 'Posts' : 'Post'" :metaCount="profile.post_count"></text-meta-count>
                            <text-meta-count class="ml-3" 
                            :to="`/${profile.username}/following/`"
                            replace
                            metaName="Following" :metaCount="profile.following_count"></text-meta-count>
                            <text-meta-count class="ml-3" 
                            :to="`/${profile.username}/followers/`"
                            replace
                            :metaName="profile.followers_count > 1 ? 'Followers' : 'Follower'" :metaCount="profile.followers_count"></text-meta-count>
                        </div>
                        <div class="d-flex flex-row flex-wrap mt-2" v-if="isDesktop">
                            <text-meta-count metaName="Projects" :metaCount="0"></text-meta-count>
                            <text-meta-count class="ml-3" metaName="Credits" :metaCount="0"></text-meta-count>
                            <text-meta-count class="ml-3" metaName="Competition" :metaCount="0"></text-meta-count>
                        </div>
                        <div class="mt-4 d-flex align-center" v-if="isDesktop">
                            <span class="name title">{{ profile.name }}</span>&nbsp;
                            <v-btn text :to="`/${profile.username}/rate/`" replace color="textLinks" class="subtitle-2 text-capitalize">
                                <v-icon left>mdi-thumb-up</v-icon> Rate {{profile.username}}
                            </v-btn>
                        </div>
                    </v-card>
                </v-col>
                <v-col v-if="!isDesktop" cols="12">
                    <span class="name">{{ profile.name }}</span>
                </v-col>
            </v-row>
            <v-row v-if="!isDesktop">
                <v-divider></v-divider>
            </v-row>
            <v-row v-if="!isDesktop">
                <v-col cols="12">
                    <v-slide-group multiple>
                        <div class="px-4 py-2 text-center">
                            <text-meta-count block :metaName="profile.post_count > 1 ? 'Posts' : 'Post'" :metaCount="profile.post_count"></text-meta-count>
                        </div>
                        <div class="px-4 py-2 text-center">
                            <text-meta-count
                            block
                            :to="`/${profile.username}/following/`"
                            replace
                            metaName="Following" :metaCount="profile.following_count"></text-meta-count>
                        </div>
                        <div class="px-4 py-2 text-center">
                            <text-meta-count
                            block
                            :to="`/${profile.username}/followers/`"
                            replace
                            :metaName="profile.followers_count > 1 ? 'Followers' : 'Follower'" :metaCount="profile.followers_count"></text-meta-count>
                        </div>
                        <div class="px-4 py-2 text-center">
                            <text-meta-count block metaName="Projects" :metaCount="0"></text-meta-count>
                        </div>
                        <div class="px-4 py-2 text-center">
                            <text-meta-count block metaName="Credits" :metaCount="0"></text-meta-count>
                        </div>
                        <div class="px-4 py-2 text-center">
                            <text-meta-count block metaName="Competition" :metaCount="0"></text-meta-count>
                        </div>
                    </v-slide-group>
                </v-col>
            </v-row>
            <v-row v-if="!isDesktop">
                <v-divider></v-divider>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import {
    GET_CURRENT_USER
} from "@/store/actions.type"
import {
    UPDATE_ACTIVE_PROFILE
} from "@/store/mutations.type"

import profileAvatar from "./profile-avatar.vue"
import userMixin from "@/mixins/mixin-users"
import followBtn from "@/components/buttons/follow-button.vue"
export default {
    mixins: [userMixin],
    created() {
        if (this.profile.username !== this.username) {
            this.$store.dispatch(GET_CURRENT_USER, {
                username: this.username
            })
        }
    },

    props: {
        username: String
    },

    data: () => ({}),
    components: {
        'profile-avatar': profileAvatar,
        'btn-follow': followBtn
    },

    methods: {
        followUnfollow() {
            if (!this.profile.following) {
                this.follow(this.profile.id, () => {
                    this.$store.commit(UPDATE_ACTIVE_PROFILE, {
                        following: true,
                        followers_count: this.profile.followers_count + 1
                    })
                })
            } else {
                this.unFollow(this.profile.id, () => {
                    this.$store.commit(UPDATE_ACTIVE_PROFILE, {
                        following: false,
                        followers_count: this.profile.followers_count - 1
                    })
                })
            }
        }
    },

    computed: {
        editOptions() {
            return this.profile.id === this.user.id
        },

        profile() {
            return this.$store.state.profile.activeProfile
        },

        profileLoading() {
            return this.$store.state.profile.activeProfileLoading
        }
    }
}
</script>